import CustomMidwayClient from '../../client/CustomMidwayClient';
import { getSelfServiceEndpointConfig } from './spotcp-self-service-endpoint-configs';

export default class MidwayClient {
  selfServiceClient;

  constructor() {
    const endpointConfig = getSelfServiceEndpointConfig();
    this.selfServiceClient = new CustomMidwayClient(endpointConfig);
  }
}



// WEBPACK FOOTER //
// ./src/components/spotlight/spotcp-midway_client.jsx